import { useContext } from 'react';
import { TOAST_SEVERITY } from './constants';
import { ToastContext } from './context';
import type { ToastOptions } from './types';

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return {
    show: ctx.show,
    dismiss: ctx.dismiss,
    success: (title: string, options?: ToastOptions) =>
      ctx.show(title, TOAST_SEVERITY.SUCCESS, options),
    warning: (title: string, options?: ToastOptions) =>
      ctx.show(title, TOAST_SEVERITY.WARNING, options),
    error: (title: string, options?: ToastOptions) =>
      ctx.show(title, TOAST_SEVERITY.ERROR, options),
  };
};
